import { colorGroup } from '@/styles/common';
import { flex } from '@/styles/minix';
import styled from 'styled-components';

export const EmptyWrap = styled.div`
	height: 100%;
	position: relative;
	color: ${colorGroup.textSlight};
	font-size: 14px;
	${flex('column', 'center', 'center')}
	text-align: center;

	& .empty-tip {
		margin-top: 12px;
	}
`;
